import React from 'react'

export default ({iban}) => {
    iban.match(/.{1,4}/g)
  return (
      <React.Fragment>
    {iban.match(/.{1,4}/g).map(s =>(<span style={{paddingLeft: '0.2em'}}>{s}</span>))}
    </React.Fragment>
  )
}
